import { useEffect, useState } from "react";

export const RELATIVE_TIME_REFRESH_MS = 10_000;

export function useRelativeTimeClock(enabled: boolean = true): number {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled) {
      return;
    }
    const timer = setInterval(() => setNowMs(Date.now()), RELATIVE_TIME_REFRESH_MS);
    return () => clearInterval(timer);
  }, [enabled]);

  return nowMs;
}
